import { useMemo } from 'react'
import useRemainingTime from 'hooks/useRemainingTime'
import { parseReservationExpiresAt } from 'lib/experiences/experienceReservationUtils'

export function useExperienceReservationExpiryTimer(reservationExpiresAt: string | undefined) {
  const initialTotalRemainingSeconds = useMemo(() => {
    const expiryTimestamp = parseReservationExpiresAt(reservationExpiresAt)
    if (!expiryTimestamp) return 0

    return Math.max(0, Math.floor((expiryTimestamp - Date.now()) / 1000))
  }, [reservationExpiresAt])

  const remainingTime = useRemainingTime(initialTotalRemainingSeconds)

  const timeRemaining = remainingTime
    ? {
        minutes: remainingTime.hours * 60 + remainingTime.minutes,
        seconds: remainingTime.seconds,
      }
    : undefined

  return { timeRemaining }
}
